import * as React from 'react';
import { useRouteMatch } from 'react-router';
import { Flex } from '@qga/roo-ui/components';
import EdsHeader from 'components/EdsHeader';
import GlobalHeader from 'components/GlobalHeader';
import GlobalFooter from 'components/GlobalFooter';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { EDS_SITE_NAV } from 'config/constants';

const GlobalLayout: React.FC = ({ children }) => {
  const printPageMatch = useRouteMatch('/bookings/:bookingId/print');

  const { isReady, isEnabled } = useFeatureFlag(EDS_SITE_NAV);

  if (!isReady) {
    return null;
  }

  if (printPageMatch) {
    return <>{children}</>;
  }

  return (
    <Flex flexDirection="column" minHeight="100vh">
      <Flex flex="1 0 auto" flexDirection="column" width="100%" bg="greys.porcelain">
        {isEnabled ? <EdsHeader /> : <GlobalHeader />}
        <Flex id="content" flex="1 0 auto" flexDirection="column">
          {children}
        </Flex>
      </Flex>
      <GlobalFooter />
    </Flex>
  );
};

export default GlobalLayout;
